import { useCallback, useState } from 'react';
import { api } from '@tripian/core';
import { useDispatch } from 'react-redux';
import Model from '@tripian/model';
import useTrip from './useTrip';
import { saveError } from '../redux/action/user';

const useSearchPoi = () => {
  const { tripReference } = useTrip();

  const [loadingTastePois, setLoadingTastePois] = useState<boolean>(false);
  const [tastePois, setTastePois] = useState<Model.Poi[]>([]);

  const dispatch = useDispatch();

  const searchPoi = useCallback((query: string, searchPoiCategories?: number[], page?: number) => api.poisNameSearch({ cityId: tripReference?.city.id, name: query, poiCategories: searchPoiCategories, limit: 20, page }), [tripReference]);

  const tastePoisFetch = useCallback(
    (tasteId: number): Promise<Model.Poi[]> => {
      setLoadingTastePois(true);

      return api
        .poisMustTrySearch({ cityId: tripReference?.city.id || 0, mustTryIds: [tasteId], limit: 100 })
        .then((tastePoisResponse) => {
          setTastePois(tastePoisResponse);
          return tastePoisResponse;
        })

        .catch((tastePoisFetchError) => {
          dispatch(saveError('tastePoisFetch', 'Taste Pois Fetch', tastePoisFetchError));
          throw tastePoisFetchError;
        })
        .finally(() => {
          setLoadingTastePois(false);
        });
    },
    [dispatch, tripReference],
  );

  return { searchPoi, tastePoisFetch, tastePois, loadingTastePois };
};

export default useSearchPoi;
